import { render, staticRenderFns } from "./PerDiemForm.vue?vue&type=template&id=24a13daf&scoped=true&"
import script from "./PerDiemForm.vue?vue&type=script&lang=js&"
export * from "./PerDiemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a13daf",
  null
  
)

export default component.exports